import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Badge, type BadgeProps } from '../badge/Badge';

import { getDataRole } from './Panel.helpers';
import { type DataRoleProps, type PanelIntent } from './Panel.types';

import './PanelStatusBadge.less';

const block = bemBlock('n-Panel');

export type PanelStatusBadgeProps = Omit<BadgeProps, 'color'> &
  DataRoleProps & {
    intent?: PanelIntent | 'disabled';
    label?: React.ReactNode;
  };

export const PanelStatusBadge = ({
  children,
  className,
  dataRole,
  intent = 'info',
  label,
  'data-role': dataRoleAttribute,
  ...passProps
}: PanelStatusBadgeProps) => (
  <Badge
    {...passProps}
    color={getBadgeColor(intent)}
    data-role={getDataRole(dataRole, dataRoleAttribute)}
    className={block({ element: 'status-badge', modifiers: { intent }, extra: className })}
  >
    {children ?? label}
  </Badge>
);

function getBadgeColor(intent: PanelStatusBadgeProps['intent']): BadgeProps['color'] {
  if (intent === 'warning') {
    return 'warning';
  }

  if (intent === 'success') {
    return 'success';
  }

  if (intent === 'error') {
    return 'error';
  }

  if (intent === 'disabled') {
    return 'disabled';
  }

  return 'info';
}
